<template>
  <div id="headerDiv">
    <header id="headBody">
      <span class="logo" style="padding:0" @click="toHome">
        <img class="logoImg" src="../assets/logo.png" />
      </span>
      <div>{{ isactive }}</div>
      <n-menu
        v-model:value="activeKey"
        mode="horizontal"
        style="font-size: 21px"
        :options="menuOptions"
        @click="nameSelect"
        default-value="1"
      />
      <!-- <span
        v-for="(item, index) in textList"
        :key="index"
        @click="nameSelect(index)"
        :class="{ actived: index == isactive }"
        >{{ item.name }}</span
      > -->
    </header>
  </div>
</template>
<script setup>
import router from "@/router";
import { ref } from "vue";
const activeKey = ref(sessionStorage.getItem('menu') ? sessionStorage.getItem('menu') : '1');
const menuOptions = [
  {
    label: "首页",
    key: "1",
  },
  {
    label: "关于我们",
    key: "2",
  },
  {
    label: "产品中心",
    key: "3",
  },
  {
    label: "解决方案",
    key: "4",
  },
  {
    label: "新闻中心",
    key: "5",
  },
  {
    label: "联系我们",
    key: "6",
  },
];
const textList = [
  { name: "首页" },
  { name: "关于我们" },
  { name: "产品中心" },
  { name: "解决方案" },
  { name: "新闻中心" },
  { name: "联系我们" },
];
const nameSelect = () => {
  let index = activeKey.value
  if (index == 1) {
    router.push("/");
    sessionStorage.setItem('menu', 1);
  } else if (index == 2) {
    router.push("/");
    sessionStorage.setItem('menu', 2);
    setTimeout(() => {
      document.getElementById("isUS").scrollIntoView();
    }, 10);
  } else if (index == 3) {
    router.push("Product");
    sessionStorage.setItem('menu', 3);
  } else if (index == 4) {
    router.push("TheCase");
    sessionStorage.setItem('menu', 4);
  } else if (index == 5) {
    router.push("News");
    sessionStorage.setItem('menu', 5);
  } else {
    router.push("ContactUs");
    sessionStorage.setItem('menu', 6);
  }
};

const toProduct = () => {
  router.push("Product");
};

const toHome = () => {
  router.push("/");
};
const toUS = () => {
  router.push("/");
  setTimeout(() => {
    document.getElementById("isUS").scrollIntoView();
  }, 10);
};

const toTheCase = () => {
  router.push("TheCase");
};
const toNews = () => {
  router.push("News");
};
const toContactUs = () => {
  router.push("ContactUs");
};

</script>
<style scoped>
#headerDiv{
  position: relative;
  margin-bottom: 8vh;
}
.ulSpan {
  display: flex;
  margin-left: 55px;
}
.actived {
  font-weight: 500;
  color: #3aaeff;
}
.liSpan {
  padding: 11px 20px;
  margin-left: 13px;
  border-radius: 2px 0px 0px 2px;
  opacity: 1;
  border: 1px solid #59bad5;
  font-size: 22px;
  font-weight: 400;
  color: #3aaeff;
  cursor: pointer;
}

#headBody {
  text-align: center;
  background: rgba(255, 255, 255, 0.2);
  line-height: 8vh;
  color: #333;
  position: fixed;
  top: 0;
  z-index: 9999;
  border-bottom: 1px solid #eee;
  background: white;
  width: 100%;
}
.logo {
  padding: 0;
  width: 5vw;
  height: 5vh;
  text-align: left;
  display: inline-block;
  float: left;
  margin-left: 3vw;
  /* position: absolute;
  left: 5vw;
  top: -5vh; */
}
#headBody span {
  padding: 5vh;
  font-size: 16px;
  cursor: pointer;
}
.logoImg {
  max-height: 5vh;
  margin-top: 1.5vh;
  padding-right: 4vw;
}
</style>